import React from 'react';

import ExpensesTab from '../expense/ExpensesTab';

export const TABS = ['Expenses', 'Predefined Expenses'];

const ProjectExpensesManagement = () => (
  <div className="text-2xl font-bold px-12 pb-6">
    <ExpensesTab />
  </div>
);

export default ProjectExpensesManagement;
